<ca-avatar
  [class]="size"
  *ngFor="let avatar of avatars | pureslice: 0:maxAvatars; let i = index"
  [fullName]="avatar.fullName"
  [image]="avatar.image"
  [style.zIndex]="20 - i"
></ca-avatar>
